<dashboard-frame>
	<div class='navbar-content'>
		<search-widget></search-widget>
	</div>
	<div class="page-content">
		<router-outlet />
	</div>
</dashboard-frame>